<navbar-component></navbar-component>

<main class="img-background">
  <div style="display: flex; flex-direction: column; min-height: 80vh;">

    <div class="label-wrapper">
      <img class="label-img" src="assets/fotos/plastics-head.svg" />
    </div>

    <div class="container">
      <div class="information-container">
        <div class="information">
          <div class="information-title">
            O PROJETO:
          </div>
          <div class="information-subtitle">
            O projeto Moda e Plástico: Resíduos indiretos, efeitos negativos diretos
          </div>
          <div class="information-text">
            Aprovado no edital Funcultura 2019/2020, trabalha com resíduos plásticos do polo da moda (suas confecções, lavanderias e lojas) para sua transformação em nova matéria-prima com sua aplicação em produtos de design e moda.  Essa transformação acontece com os processos de trituração e o derretimento dos plásticos, formando placas plásticas.
          </div>
        </div>

        <div class="plastics-images">
          <img style="width: 100%;" src="assets/fotos/circulos-plasticos.svg" />
        </div>
      </div>

      <div class="leavings-container">
        <button class="button" routerLink="/plastics-showcase" mat-button>
          <mat-icon class="result-img" svgIcon="result"></mat-icon>
        </button>
        <img style="width: 100%;" src="assets/fotos/plastics-bench.svg" />
      </div>
    </div>

  </div>
</main>

<footer-component></footer-component>
